import { render } from "./FooterItem.vue?vue&type=template&id=5bea3477&scoped=true&ts=true"
import script from "./FooterItem.vue?vue&type=script&lang=ts"
export * from "./FooterItem.vue?vue&type=script&lang=ts"

import "./FooterItem.vue?vue&type=style&index=0&id=5bea3477&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bea3477"]])

export default __exports__